import { useCallback, useEffect, useState } from "react";

import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";

interface UserRole {
  id: string;
  name: string;
  dealerChoice: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export const useRoleOptions = (): FilterFieldOptionsHookResult => {
  const [options, setOptions] = useState<FilterFieldOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchRoles = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch("/internal-api/auth/access/roles", {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data: { roles: UserRole[] } = await response.json();

      const uniqueNames = new Set<string>();
      const uniqueRoles: UserRole[] = [];
      for (const role of data.roles) {
        if (!uniqueNames.has(role.name)) {
          uniqueNames.add(role.name);
          uniqueRoles.push(role);
        }
      }

      setOptions(
        uniqueRoles.map((role) => ({
          value: role.name,
          label: role.name,
        })),
      );
    } catch (error) {
      console.error("Ошибка загрузки ролей:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  return { options, loading };
};
